export default {"src":"/_next/static/media/benefit_revenue.60cb7aef.svg","height":400,"width":400};